import { render, staticRenderFns } from "./PaymentPromiseDialog.vue?vue&type=template&id=0b44030c&scoped=true&"
import script from "./PaymentPromiseDialog.vue?vue&type=script&lang=ts&"
export * from "./PaymentPromiseDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b44030c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b44030c')) {
      api.createRecord('0b44030c', component.options)
    } else {
      api.reload('0b44030c', component.options)
    }
    module.hot.accept("./PaymentPromiseDialog.vue?vue&type=template&id=0b44030c&scoped=true&", function () {
      api.rerender('0b44030c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_payment-plan/components/PaymentPromiseDialog.vue"
export default component.exports